import Tooltip from '@material-ui/core/Tooltip';

import React from 'react';

const CKPTooltip = ({ children, title }) => {
    if (title) {
        return (
            <Tooltip
                classes={{ popper: 'ckp-tooltip' }}
                placement="bottom-start"
                disableFocusListener
                disableTouchListener
                title={title}
                enterDelay={750}
                leaveDelay={200}
            >
                {children}
            </Tooltip>
        );
    } else {
        return children;
    }
};

export default CKPTooltip;



// WEBPACK FOOTER //
// ./src/components/forms/Tooltip.js